import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import AppStoreBadges, {
  reassistAppStoreUrl,
} from "../../components/AppStoreBadges";
import { isMobile } from "react-device-detect";

const apps = [
  {
    name: "Real Estate Agent Assist",
    featured: true,
    tagline: "The pocket companion for real estate agents.",
    description:
      "Manage listings, track commissions, and never miss a closing date. Your data stays on your device or in your own cloud storage — no accounts, no tracking.",
    platform: "iPhone and Android",
    status: "Available on the App Store and Google Play",
    // Built at render so it picks up the page's utm_campaign.
    appStoreUrl: reassistAppStoreUrl,
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.crossvisiondevstudios.reassist",
    path: "/apps/real-estate-assist",
    privacyPath: "/apps/real-estate-assist/privacy",
    supportPath: "/apps/real-estate-assist/support",
    howToPath: "/apps/real-estate-assist/how-to",
  },
];

const Apps = () => {
  return (
    <Container fluid style={styles.container}>
      <Container>
        <Row className="mb-2">
          <h1 style={styles.title}>Our Apps</h1>
        </Row>
        <Row className="mb-5">
          <p style={styles.subtitle}>
            Apps designed and built in-house by Cross Vision Development
            Studios.
          </p>
        </Row>
        <Row>
          {[...apps]
            .sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0))
            .map((app) => (
            <Col xs={12} md={6} lg={4} key={app.name} className="mb-4">
              <div
                style={
                  app.featured
                    ? { ...styles.appCard, ...styles.appCardFeatured }
                    : styles.appCard
                }
              >
                {app.featured && (
                  <span style={styles.featuredBadge}>Featured</span>
                )}
                <h3 style={styles.appName}>{app.name}</h3>
                <p style={styles.appTagline}>{app.tagline}</p>
                <p style={styles.appDescription}>{app.description}</p>
                <p style={styles.appMeta}>
                  {app.platform} &middot; {app.status}
                </p>
                <Button
                  variant="primary"
                  as={Link}
                  to={app.path}
                  style={styles.learnMoreButton}
                >
                  Learn More
                </Button>
                {(app.appStoreUrl || app.playStoreUrl) && (
                  <div style={styles.storeBadges}>
                    <AppStoreBadges
                      height={isMobile ? 34 : 40}
                      align="left"
                      appStoreUrl={app.appStoreUrl?.()}
                      playStoreUrl={app.playStoreUrl}
                    />
                  </div>
                )}
                <p style={styles.appLinks}>
                  <Link to={app.privacyPath} className="footer-link">
                    Privacy Policy
                  </Link>
                  {" · "}
                  <Link to={app.supportPath} className="footer-link">
                    Support
                  </Link>
                  {app.howToPath && (
                    <>
                      {" · "}
                      <Link to={app.howToPath} className="footer-link">
                        How-to videos
                      </Link>
                    </>
                  )}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
};

export default Apps;

const styles = {
  appCard: {
    backgroundColor: "#1C1816",
    borderRadius: 8,
    height: "100%",
    padding: 32,
    textAlign: "left",
  },
  appCardFeatured: {
    border: "1px solid #CF3620",
  },
  appDescription: {
    color: "#ACACAC",
    fontSize: 16,
    lineHeight: 1.6,
  },
  appLinks: {
    color: "#ACACAC",
    fontSize: 14,
    marginTop: 16,
    marginBottom: 0,
  },
  appMeta: {
    color: "#ACACAC",
    fontSize: 14,
    fontStyle: "italic",
    marginBottom: 20,
  },
  appName: {
    color: "#FFF",
    fontWeight: 700,
    marginBottom: 4,
  },
  appTagline: {
    color: "#CF3620",
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 12,
  },
  container: {
    backgroundColor: "#000",
    paddingTop: 120,
    paddingBottom: 120,
  },
  featuredBadge: {
    display: "inline-block",
    backgroundColor: "#CF3620",
    color: "#FFF",
    fontSize: 12,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 1,
    padding: "4px 10px",
    borderRadius: 4,
    marginBottom: 12,
  },
  storeBadges: {
    marginTop: 20,
  },
  learnMoreButton: {
    minWidth: 140,
    fontWeight: 600,
  },
  subtitle: {
    color: "#ACACAC",
    fontSize: 18,
  },
  title: {
    color: "#FFF",
    fontWeight: 700,
  },
};
